import { render, staticRenderFns } from "./ExtensionsShop.vue?vue&type=template&id=6b110893"
import script from "./ExtensionsShop.vue?vue&type=script&lang=js"
export * from "./ExtensionsShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports